import React from "react";
import { Section, Typography } from "../../../core";
import { theme, MixStyle, media } from "../../../styles";
import styled from "styled-components";
import { useHistory } from "react-router-dom";

import { Row, Col, Space } from "antd";
import { FormOutlined } from "@ant-design/icons";

import moment from "moment";
const FIXED_TO = require("../../../helper/utils/Fixed");

const { colors, textColor } = theme;

const TypoProps = {
  label: {
    as: "h5",
    weight: "500",
    color: textColor.primary,
  },
  value: {
    as: "h6",
    color: " #6789C5",
    weight: "bold",
  },
};

const Wraper = styled.div`
  ${MixStyle.flexBetween}
  span {
    font-size: 16px;
    line-height: 20px;
    letter-spacing: 0.2px;
    color: #404e67;
  }
  svg {
    width: 20.12px;
    height: 20.12px;
    color: ${colors.Fiord};
    margin: 0px 5px;
  }
`;

const Container = styled.div`
  .general-info {
    ${MixStyle.flexBetween};
    ${media.tablet`display:block;`};
    flex-flow: row wrap;
    > div {
      max-width: 100%;
      width: 50%;
      display: flex;
      align-items: center;
      ${MixStyle.flexStart};
      ${media.tablet`width:100%;  ${MixStyle.flexBetween}`};
    }
  }
`;

const StyledTable = styled.table`
  margin: 20px 0px;
  width: 100%;
  thead {
    background: #233b67;
    color: white;
  }
  th,
  td {
    height: 50px;
    text-align: center;
    border: 1px solid #233b67;
    font-weight: 500;
    font-size: 16px;
  }
`;

export const GeneralInfo = ({
  contractInfo: {
    contractNo,
    _id,
    contractDate,
    brokerRate,
    brokerName,
    contract_status,
    fabricRatePerMeter,
    quantity,
    type,
    buyerCompanyId,
    clothQulaityId,
    delieverySchedule,
  },
}) => {
  let history = useHistory();
  const editContractHandler = () => {
    history.push({
      pathname: `/edit/${type}-contract/${contractNo}`,
      state: _id,
    });
  };
  return (
    <Section padding="20px">
      <Container>
        <Wraper>
          <Typography
            color={textColor.primary}
            letterSpacing="0.2"
            weight="bold"
            as="h3"
          >
            General :
          </Typography>
          <div>
            <FormOutlined color="#404E67" onClick={editContractHandler} />

            <span>Edit</span>
          </div>
        </Wraper>
        <Row type="flex" justify="space-between" gutter={[16, 16]}>
          <Col xl={12} xs={24}>
            <div className="general-info d-flex v-center">
              <div>
                <Typography {...TypoProps.label} text="Contact # : " />
                <Typography {...TypoProps.value} text={contractNo} />
              </div>
              <div>
                <Typography {...TypoProps.label} text="Contract Date : " />
                <Typography
                  {...TypoProps.value}
                  text={moment(contractDate).format("MM-DD-YYYY")}
                />
              </div>
              <div>
                <Typography {...TypoProps.label} text="Quantity : " />
                <Typography {...TypoProps.value} text={quantity} />
              </div>
              <div>
                <Typography {...TypoProps.label} text="Fabric Rate : " />
                <Typography
                  {...TypoProps.value}
                  text={FIXED_TO.round_of_two(fabricRatePerMeter)}
                />
              </div>

              <div>
                <Typography
                  {...TypoProps.label}
                  text="Status : "
                  // text="Brand : "
                />
                <Typography {...TypoProps.value} text={contract_status} />
              </div>
              <div>
                <Typography {...TypoProps.label} text="Broker Name : " />
                <Typography {...TypoProps.value} text={brokerName} />
              </div>
              <div>
                <Typography {...TypoProps.label} text="Broker Rate : " />
                <Typography {...TypoProps.value} text={brokerRate} />
              </div>
            </div>
            {/* {rate_per_pick ? (
              <div className="d-flex">
                <Space>
                  <Typography {...TypoProps.label} text="Rate Per Pick: " />

                  <Typography {...TypoProps.value} text={rate_per_pick} />
                </Space>
              </div>
            ) : null} */}

            <div className="d-flex">
              <Space>
                <Typography {...TypoProps.label} text="Cloth Quality : " />
                <Typography
                  {...TypoProps.value}
                  as="span"
                  text={` ${clothQulaityId ? clothQulaityId.reed : ""} * ${
                    clothQulaityId ? clothQulaityId.pick : ""
                  } / ${clothQulaityId ? clothQulaityId.warp : ""} * ${
                    clothQulaityId ? clothQulaityId.weft : ""
                  } = ${clothQulaityId ? clothQulaityId.width : ""}" ${
                    clothQulaityId ? clothQulaityId.type : ""
                  }`}
                />
              </Space>
            </div>
          </Col>
          <Col xl={12} xs={24}>
            <div>
              <Typography {...TypoProps.label} text="Deilivery Schedule : " />
              <StyledTable>
                <thead>
                  <tr>
                    <th>Sr #</th>
                    <th>Date</th>
                    <th>Meter</th>
                  </tr>
                </thead>
                <tbody>
                  {delieverySchedule?.length > 0 ? (
                    delieverySchedule.map((deliverySchedule, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>
                          {moment(deliverySchedule.date).format("MM-DD-YYYY")}
                        </td>
                        <td>{deliverySchedule.meter}</td>
                      </tr>
                    ))
                  ) : (
                    <td colSpan="3">No Delivery Schedule Availabel </td>
                  )}
                </tbody>
              </StyledTable>
            </div>
          </Col>
        </Row>
      </Container>
    </Section>
  );
};
